/**
 * Public /tools/wealth-plan — shareable, un-authenticated version of the
 * wealth projection calculator. Optimised for social-ad landing:
 *   - No login required, calculator instantly usable
 *   - Sign-up nudge at the end that carries the inputs into /signup
 *   - Minimal chrome so link previews and copy-paste look clean
 */
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useEffect } from "react";

import Brand from "@/components/Brand";
import WealthPlanCalculator from "@/components/WealthPlanCalculator";

export default function ToolsWealthPlan() {
    const nav = useNavigate();

    useEffect(() => {
        // Update the tab title so socials that use the browser title look
        // clean when this URL is pasted into a chat / DM.
        const prev = document.title;
        document.title = "Grow my wealth — free NZ projection tool · ClientOps";
        return () => { document.title = prev; };
    }, []);

    function nudgeToSignup(inputs) {
        // Carry the inputs across as base64-encoded JSON so the eventual
        // portal page can rehydrate them post-signup.
        let planParam = "";
        try {
            planParam = btoa(encodeURIComponent(JSON.stringify(inputs)));
        } catch { /* ignore */ }
        nav(`/signup?next=/portal/wealth-plan${planParam ? `&plan=${planParam}` : ""}`);
    }

    return (
        <div className="min-h-screen bg-[#F5F4EF]">
            <header className="mx-auto max-w-4xl px-4 py-6 flex items-center justify-between">
                <Brand size="sm" data-testid="tools-brand-home" />
                <div className="flex items-center gap-4">
                    <a
                        href="https://nztaxation.nz/rentals"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[13px] text-[#5E636E] hover:text-[#0F1115]"
                        data-testid="tools-rental-tax-link"
                    >
                        Rental tax services
                    </a>
                    <Link to="/login" className="text-[13px] text-[#5E636E] hover:text-[#0F1115]" data-testid="tools-signin-link">Sign in</Link>
                </div>
            </header>
            <main className="mx-auto max-w-4xl px-4 pb-16">
                <WealthPlanCalculator mode="public" onSignupNudge={nudgeToSignup} />
            </main>
            <footer className="border-t border-[#E4E4E7] bg-white">
                <div className="mx-auto max-w-4xl px-4 py-6 text-[12px] text-[#5E636E] flex flex-wrap gap-x-4 gap-y-2 justify-between">
                    <span>© ClientOps NZ · Grow smart, keep more.</span>
                    <Link to="/privacy" className="hover:text-[#0F1115]">Privacy</Link>
                    <Link to="/support" className="hover:text-[#0F1115]">Support</Link>
                </div>
            </footer>
        </div>
    );
}
